import { render } from "./ManualSubjectIdsInput.vue?vue&type=template&id=f2360a4a&scoped=true"
import script from "./ManualSubjectIdsInput.vue?vue&type=script&lang=js"
export * from "./ManualSubjectIdsInput.vue?vue&type=script&lang=js"

import "./ManualSubjectIdsInput.vue?vue&type=style&index=0&id=f2360a4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2360a4a"]])

export default __exports__